'use client';

import { Accordion } from './accordion/accordion';
import { useFooterLinks } from './footer-links-data';
import footerLinkStyles from './footer-links.module.scss';

export const FooterLinks = (): React.JSX.Element => {
  const { footerLinks } = useFooterLinks();

  return (
    <div className={footerLinkStyles.links}>
      {footerLinks.map((link, index) =>
        <Accordion key={index}
          {...link}
        />
      )}
    </div>
  );
};
